import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';
import { Map, Record, List } from 'immutable';


export const Report = Record({ id: 0, name: 'Report', path: 'report', views: new List() });

export class View extends Record({ default: false, id: 0, index: 0,
  name: 'View', viewPath: 'Report/View' }) {
  url(ticket) {
    return `${ticket}${this.viewPath}`;
  }

  staticView(ticket, url) {
    return `${ticket}${url}`;
  }

  reportPath() {
    return this.viewPath.split('/')[0];
  }
}

class ReportStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.WORKBOOKS_RECEIVED:
        return this.loadWorkbooks(state, action.workbooks);
      default:
        return state;
    }
  }


  loadWorkbooks(state, workbooks) {
    return state.withMutations(wbs =>
      workbooks.forEach((wb) => {
        const views = new List(wb.views.map((v) =>
          new View({ id: v.id, name: v.name, index: v.index, default: v.default,
            viewPath: v.view_path }))
        ).sortBy(v => v.index);
        const reportPath = views.first().reportPath();
        wbs = wbs.set(reportPath, new Report({ id: wb.id, path: reportPath,
          name: wb.name, views }));
      })
    );
  }

  getWorkbooksAlphabetical() {
    return this.getState().toList().sortBy((wb) => wb.name);
  }

  getViews() {
    return this.getState().map((v) => v.views);
  }
}

const instance = new ReportStore(AppDispatcher);
export default instance;
